module.exports = __webpack_public_path__ + "img/composition-nav.8cfe624d.png";